import { Box, Dialog, DialogContent, DialogActions, Button, Grid, IconButton, Skeleton, Theme, Typography } from "@mui/material";
import { ReportsRightLayout } from "../../InvestorReport";
import { Form, Formik, FormikProps } from "formik";
import * as yup from "yup"
import dayjs from "dayjs";
import MFSelectField from "../../../lib/formik/SelectField";
import { TextDatePicker } from "../../onboarding/DatePickerWithTextFeild";
import { MFSubmitButton } from "../../../lib/formik";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { RootStateType } from "../../../redux-store/reducers";
import { getReportsInvestorList, getReportsTransactionHistory } from "../../../redux-store/actions/reports";
import { ReportsListObj, ReportsListRes } from "../../../redux-store/types/api-types";
import { DayJsDatePicker } from "../../onboarding/newDatePicker";
import { SuccessIcon, FailureIcon, DialogCloseIcon, YellowWarning } from "../../../assets/SvgIcons";
import { reportDownload } from "../../Reports/report-utils";
import { maskInfo } from "../../../utils/utilityFunctions";
import FormikSearchDropdown from "../../../lib/formik/FormikSearchDropdown";
import { CONTENT_TYPE } from "../../../utils/constant";


// export function TransactionHistoryReport() {
//     const theme = useTheme();
//     const dispatch = useDispatch();
//     const { enqueueSnackbar } = useSnackbar();
//     const history = useHistory();
//     const [loading, setLoading] = useState<boolean>(false);
//     const currentDate = dayjs();
//     const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
//     const [dates1, setDates1] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
//     const [dashBoardMetricsData, setDashBoardMetricsData] = useState<RmDashboardType | null>(null);

//     useEffect(() => {
//         let isComponentActive = true;
//         setDashBoardMetricsData(null);
//         (async function () {
//             try {
//                 // const response = (await dispatch(getRMDashBoardMetrics())) as RmDashboardType;
//                 if (!isComponentActive) {
//                     return;
//                 }
//                 setDashBoardMetricsData({});
//                 // console.log("response>>>", response)
//             } catch (e) {
//                 // setLoading(false);
//                 console.log((e as Error).message);
//             }
//         })();
//         return () => {
//             isComponentActive = false;
//         };

//     }, []);

//     const onSubmit = async (ClientCode: any, setSubmitting: (isSubmitting: boolean) => void) => {

//         console.log("first hi ClientCode : ", ClientCode)
//         console.log("set loading ", loading)
//         try {
//             setSubmitting(true);

//             // const Fchar = "W"
//             // const mClientCode: string = Fchar + ClientCode.slice(1);
//             // console.log("modifiedString data: ", mClientCode)
//             setLoading(true);
//             const res = await dispatch(
//                 getDashboardReports({
//                     reportName: 'TransactionHistoryReport',
//                     ClientCode: ClientCode,
//                 })
//             );
//             setLoading(false);
//             console.log(`Generating report for investor with id: ${ClientCode}`);
//             console.log("response ", res)
//             downloadMultipleFiles(res);

//             formik.setFieldValue('selectedInvestor', { ClientId: "", clientName: "" });
//             enqueueSnackbar('File(s) downloaded successfully.', {
//                 variant: 'success',
//                 autoHideDuration: 3000,
//             });
//             // console.log("set loading after ..>> ", isLoading)
//         }
//         catch (e) {
//             setLoading(false);
//             console.error((e as Error).message);
//         } finally {
//             setSubmitting(false);
//         }
//     };
//     const investorSelection = [
//         "a", "b", "c"
//     ]

//     const ITEM_HEIGHT = 48;
//     const ITEM_PADDING_TOP = 8;
//     const MenuProps = {
//         PaperProps: {
//             style: {
//                 maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//                 width: 250,
//             },
//         },
//     };
//     const initialValues = {
//         selectedInvestor: { ClientId: "", clientName: "" }
//     };
//     const handleSubmit = (values: any, { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }) => {
//         onSubmit(formik.values.selectedInvestor.ClientId, setSubmitting);
//     };

//     const formik = useFormik({
//         initialValues,
//         onSubmit: handleSubmit,
//     });

//     return (
//         <ReportsRightLayout>
//             <Typography
//                 variant='h2'
//                 sx={{
//                     color: 'text.primary',
//                     lineHeight: '25px',
//                     letterSpacing: '0.01px',
//                     mb: '40px'
//                 }}>
//                 Transaction History Report
//             </Typography>
//             <Formik
//                 validationSchema={validationSchemaPortfolioSummary}
//                 initialValues={{
//                     date: new Date(),
//                     fileType: 'pdf',
//                 }}
//                 onSubmit={() => { onSubmit(formik.values.selectedInvestor.ClientId, () => { (true) }) }}>
//                 {({ values, setFieldValue, errors }) => (
//                     <Form>
//                         {/* <ReportSectionContainer>
//                             <Stack>
//                                 <Typography
//                                     sx={{
//                                         fontSize: '14px',
//                                         fontWeight: 400,
//                                         lineHeight: '22px',
//                                         letterSpacing: '0.01em',
//                                     }}>
//                                     Select Investor(s)
//                                 </Typography>
//                                 <Select
//                                     name={'reportOptions'}
//                                     label="Select Investor"
//                                     value={formik.values.selectedInvestor.ClientId || ''}
//                                     MenuProps={MenuProps}
//                                     onChange={(e) => {
//                                         const selectedInvestor = dashBoardMetricsData?.investorDetail?.find(
//                                             (investor: any) => investor.OClientID === e.target.value
//                                         );
//                                         const data = {
//                                             ClientId: selectedInvestor?.OClientID,
//                                             clientName: selectedInvestor?.I_InvName
//                                         };
//                                         formik.setFieldValue('selectedInvestor', data);
//                                     }}
//                                 >
//                                     {console.log("dashBoardMetricsData", dashBoardMetricsData)}
//                                     {dashBoardMetricsData?.investorDetail?.map((i: any, index: any) => (
//                                         <MenuItem value={i.OClientID} key={index}>
//                                             {i.I_InvName}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </Stack>
//                         </ReportSectionContainer>
//                         <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
//                             <MFSubmitButton
//                                 label="Download"
//                                 loadingEnable={loading}
//                             />
//                         </Stack> */}

//                         <Grid container rowSpacing={2} >
//                             <Grid item container columnSpacing={3}>
//                                 <Grid item xs={12} lg={6}>
//                                     <MFSelectField
//                                         name={'reportOptions'}
//                                         label="Select Investor"
//                                         items={[]}
//                                         value={formik.values.selectedInvestor.ClientId || ''}
//                                         onChange={(e: any) => {
//                                             const selectedInvestor = dashBoardMetricsData?.investorDetail?.find(
//                                                 (investor: any) => investor.OClientID === e.target.value
//                                             );
//                                             const data = {
//                                                 ClientId: selectedInvestor?.OClientID,
//                                                 clientName: selectedInvestor?.I_InvName
//                                             };
//                                             formik.setFieldValue('selectedInvestor', data);
//                                         }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} lg={6}>

//                                 </Grid>
//                             </Grid>
//                             <Grid item container columnSpacing={3}>
//                                 <Grid item xs={12} lg={6}>
//                                     <TextDatePicker
//                                         inputLabelStyles={{
//                                             transform: 'unset',
//                                             fontSize: 14,
//                                             fontWeight: 500,
//                                             color: `${theme.palette.common.black}B3`
//                                         }}
//                                         name={'#'}
//                                         placeholder='From Date'
//                                         label="From Date"
//                                         value={dayjs(dates).format('DD/MM/YYYY')}
//                                         maxDate={new Date()}
//                                         onSelect={(date: any) =>
//                                             setDates(date.format("YYYY-MM-DD"))
//                                         }
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} lg={6}>
//                                     <TextDatePicker
//                                         inputLabelStyles={{
//                                             transform: 'unset',
//                                             fontSize: 14,
//                                             fontWeight: 500,
//                                             color: `${theme.palette.common.black}B3`
//                                         }}
//                                         name={'#'}
//                                         placeholder='To Date'
//                                         label="To Date"
//                                         value={dayjs(dates1).format('DD/MM/YYYY')}
//                                         maxDate={new Date()}
//                                         onSelect={(date: any) =>
//                                             setDates(date.format("YYYY-MM-DD"))
//                                         }
//                                     />
//                                 </Grid>

//                             </Grid>
//                             <Grid item container columnSpacing={3}>
//                                 <Grid item xs={12} lg={6}>
//                                 </Grid>
//                                 <Grid item xs={12} lg={6}>
//                                     <MFSubmitButton
//                                         label="Download"
//                                         loadingEnable={loading}
//                                     />
//                                 </Grid>
//                             </Grid>

//                         </Grid>
//                     </Form>
//                 )}
//             </Formik>
//         </ReportsRightLayout>
//     );
// };

interface Values {
    selectedInvestorId: ReportsListObj | null;
    selectedFromDate: string;
    selectedToDate: string;
    downloadOption?: string;
    shareVia?: string;
}


export function TransactionHistoryReport({
    handleSideSectionDisabled
}: {
    handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element {
    const formikRef = useRef<FormikProps<Values>>(null);

    const dispatch = useDispatch()

    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setLoading] = useState<boolean>(false)
    const [investorList, setInvestorList] = useState<Array<ReportsListObj>>([])

    const [isDownloading, setDownloading] = useState<boolean>(false)

    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)

    const { iwappRmId } = useSelector((state: RootStateType) => state.id);
    const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);
    const [isSuccessDialogOpen, setIsSuccessDialogOpen] = useState<boolean>(false)
    const [isErrorDialogOpen, setIsErrorDialogOpen] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>("")

    const downloadOptions = [
        { key: 'PDF', value: 'pdf' },
        { key: 'Excel', value: 'excel' },
    ]

    const shareViaOptions = [
        { key: 'Email', value: 'email' },
        { key: 'Download', value: 'download' },
    ]
    const fetchInvestorList = async () => {
        try {
            setLoading(true);

            const payload = {
                rmId: `${iwappRmId}`
            }

            const { result = [], isSuccess, message = "" } = await (dispatch(getReportsInvestorList(payload)) as unknown as Promise<ReportsListRes>)

            if (isSuccess) {
                setInvestorList(result ?? []);

            } else if (!isSuccess) {
                setNoInvestorDialogVisible(true)
            }
        } catch (e) {
            console.log((e as Error).message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvestorList();
    }, [])


    const todayDate = new Date();
    const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");

    const initialValues: Values = {
        selectedInvestorId: null,
        selectedFromDate: formattedBusinessDate,
        selectedToDate: formattedBusinessDate,
        downloadOption: '',
        shareVia: '',
    }

    const validationSchema = yup.object().shape({
        selectedInvestorId: yup
            .object()
            .nullable()
            .test(
                "investor-required",
                "Please select an investor",
                function (value) { return !!value }
            ),
        downloadOption: yup.string().required('Please select download option'),
        shareVia: yup.string().required('Please select share or download'),
        selectedFromDate: yup
            .date()
            .required('From Date is required')
            .typeError('From Date is required')
            .min(new Date("1950-01-01"), "From Date should not be less than 01/01/1950")
            .max(formattedBusinessDate, "From Date should not be greater than system's date")
            .test('fromDateTest', 'From Date cannot be greater than To Date', function (value) {
                const { selectedToDate } = this.parent;
                return !selectedToDate || !value || value <= selectedToDate;
            }),
        selectedToDate: yup
            .date()
            .required('To Date is required')
            .typeError('To Date is required')
            .min(new Date("1950-01-01"), "To Date should not be less than 01/01/1950")
            .max(formattedBusinessDate, "To Date should not be greater than system's date")
            .test('toDateTest', 'To Date cannot be less than From Date', function (value) {
                const { selectedFromDate } = this.parent;
                return !selectedFromDate || !value || value >= selectedFromDate;
            }),
    })

    const handleSubmit = async ({
        selectedInvestorId,
        selectedFromDate,
        selectedToDate,
        downloadOption,
        shareVia
    }: Values) => {
        try {
            setDownloading(true)
            handleSideSectionDisabled(true)

            const payload = {
                clientCode: selectedInvestorId?.clientCode ?? "",
                investorName: selectedInvestorId?.customerName ?? "",
                start: dayjs(selectedFromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                end: dayjs(selectedToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                panNo: selectedInvestorId?.panNo ?? '',
                isPDF: (downloadOption ?? "").toLowerCase() === 'pdf' ? true : false,
                shareVia: (shareVia ?? "").toLowerCase() === 'email' ? 'email' : 'download',
            }

            const response = await (dispatch(getReportsTransactionHistory(payload)) as unknown as Promise<any>)
            if (shareVia?.toLowerCase() === 'download') {
                if (response.type) {
                    setIsSuccessDialogOpen(true)
                    reportDownload(response as unknown as Blob, `TransactionHistoryReport.${response.type === CONTENT_TYPE.PDF ? 'pdf' : 'xlsx'}`);
                }
                else {
                    setIsErrorDialogOpen(true)
                    setErrorMessage('File download failed!!')
                }
            }
            else if (shareVia?.toLowerCase() === 'email') {
                setIsSuccessDialogOpen(true)
            }

            // if (response.type === CONTENT_TYPE.EXCEL) {
            //     enqueueSnackbar('File downloaded successfully.', {
            //         variant: 'success',
            //         autoHideDuration: 2000,
            //     });

            //     reportDownload(response as unknown as Blob, 'TransactionHistoryReport.xlsx');
            // } else {
            //     enqueueSnackbar('File download failed!!', {
            //         variant: 'error',
            //         autoHideDuration: 2000,
            //     });
            // }

        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setDownloading(false)
            handleSideSectionDisabled(false)
        }

    }

    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }

    const handleInvestorChange = (selectedObj: Record<string, any>) => {
        if (!formikRef.current) return

        const { values, setValues } = formikRef.current ?? {}

        if (!selectedObj) {
            setValues({
                ...values,
                selectedInvestorId: null,
            })

            return
        }

        setValues({
            ...values,
            selectedInvestorId: selectedObj as ReportsListObj,
        })
    }


    return (
        <>
            <ReportsRightLayout>
                <Typography
                    variant='h2'
                    sx={{
                        color: 'text.primary',
                        lineHeight: '25px',
                        letterSpacing: '0.01px',
                        mb: { xs: '20px', sm: '40px' },
                    }}>
                    Transaction History Report
                </Typography>
                <Formik
                    innerRef={formikRef}
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ values, setFieldValue }) => (
                        <Form>
                            <Grid container spacing={3} >
                                <Grid item xs={12} lg={6}>
                                    {(isLoading || isNavbarInfoLoading) && <Skeleton
                                        animation={'wave'}
                                        height={90}

                                    />}
                                    {(!isLoading && !isNavbarInfoLoading) && (
                                        <FormikSearchDropdown
                                            name='selectedInvestorId'
                                            label='Select Investor *'
                                            options={(investorList ?? [])?.map((obj: ReportsListObj) => ({
                                                ...obj,
                                                label: `${maskInfo(obj.customerName)} (${obj?.clientCode ?? ""}) ${obj?.accountType ? " - " + obj.accountType : ""}
`,
                                                value: obj.clientCode
                                            }))}
                                            onChange={handleInvestorChange}
                                            disabled={isLoading || isDownloading || isNavbarInfoLoading}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {(isLoading || isNavbarInfoLoading) && <Skeleton
                                        animation={'wave'}
                                        height={90}

                                    />}
                                    {(!isLoading && !isNavbarInfoLoading) && (
                                        <DayJsDatePicker
                                            id=""
                                            name='selectedFromDate'
                                            label="From Date *"
                                            maxDate={new Date(formattedBusinessDate)}
                                            disabled={isLoading || isDownloading || isNavbarInfoLoading}
                                            currentDate={formattedBusinessDate}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {(isLoading || isNavbarInfoLoading) && <Skeleton
                                        animation={'wave'}
                                        height={90}

                                    />}
                                    {(!isLoading && !isNavbarInfoLoading) && (
                                        <DayJsDatePicker
                                            id=""
                                            name='selectedToDate'
                                            label="To Date *"
                                            maxDate={new Date(formattedBusinessDate)}
                                            minDate={new Date(values.selectedFromDate)}
                                            disabled={isLoading || isDownloading || isNavbarInfoLoading}
                                            currentDate={formattedBusinessDate}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {(isLoading || isNavbarInfoLoading) && <Skeleton
                                        animation={'wave'}
                                        height={90}

                                    />}
                                    {(!isLoading && !isNavbarInfoLoading) && <MFSelectField
                                        name={'downloadOption'}
                                        label="Select Download Option"
                                        items={downloadOptions}
                                        value={values.downloadOption}
                                        onChange={(e) => {
                                            setFieldValue('downloadOption', e.target.value);
                                        }}
                                        disabled={isDownloading}
                                    />}
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {(isNavbarInfoLoading) && <Skeleton
                                        animation={'wave'}
                                        height={90}

                                    />}
                                    {(!isNavbarInfoLoading) && <MFSelectField
                                        name={'shareVia'}
                                        label="Select Share or Download"
                                        items={shareViaOptions}
                                        value={values.shareVia}
                                        onChange={(e) => {
                                            setFieldValue('shareVia', e.target.value);
                                        }}
                                        disabled={isDownloading}
                                    />}
                                </Grid>
                                <Grid item container columnSpacing={3} justifyContent="flex-end" marginTop={1}>
                                    <Grid item xs={12} lg={6}>
                                        {(isLoading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!isLoading && !isNavbarInfoLoading) && <MFSubmitButton
                                            label="Proceed"
                                            loadingEnable={isDownloading}
                                            disabled={isLoading}
                                        />}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
                <Dialog
                    aria-labelledby="success-dialog"
                    open={isSuccessDialogOpen}
                    PaperProps={{
                        sx: (theme: Theme) => ({
                            maxWidth: '550px',
                            width: "100%",
                            borderRadius: "12px",
                            padding: "24px",
                            backgroundColor: theme.palette.common.white
                        }),
                    }}
                >
                    <DialogContent
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            rowGap: "12px",
                            padding: "15px",
                            overflow: "hidden"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "22px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center",
                                paddingLeft: "10px",
                                paddingRight: "10px"
                            })}
                        >
                            {formikRef.current?.values.shareVia === 'email' ? 'The statement has been  shared successfully.' : 'The statement has been downloaded successfully.'}
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            padding: "0px",
                            marginTop: "40px",
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => setIsSuccessDialogOpen(false)}
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                fontWeight: 600,
                                lineHeight: "20px",
                                color: theme.palette.common.white,
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500]
                            })}
                        >
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    aria-labelledby="error-dialog"
                    open={isErrorDialogOpen}
                    PaperProps={{
                        sx: (theme: Theme) => ({
                            maxWidth: '550px',
                            width: "100%",
                            borderRadius: "12px",
                            padding: "24px",
                            backgroundColor: theme.palette.common.white
                        }),
                    }}
                >
                    <DialogContent
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            rowGap: "12px",
                            padding: "15px",
                            overflow: "hidden"
                        }}
                    >
                        <FailureIcon width="35" height="35" />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Error!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "22px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center",
                                paddingLeft: "10px",
                                paddingRight: "10px"
                            })}
                        >
                            {errorMessage}
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            padding: "0px",
                            marginTop: "40px",
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => setIsErrorDialogOpen(false)}
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                fontWeight: 600,
                                lineHeight: "20px",
                                color: theme.palette.common.white,
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500]
                            })}
                        >
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
            </ReportsRightLayout>
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
        </>
    )
}

